export enum DOC_STATUS {
  PUBLISH = "PUBLISH",
  DRAFT = "DRAFT",
  TRASH = "TRASH",
  SHARED = "SHARED",
  TEMPLATE = "TEMPLATE",
  ARCHIVE = "ARCHIVE",
}
